import request from '@/utils/request'

/**
 * 提交题目反馈
 */
export function submitFeedback(data) {
  return request({
    url: '/amc-question-feedback/submit',
    method: 'post',
    data
  })
}

/**
 * 根据题目ID查询反馈列表
 */
export function getFeedbackByQuestionId(questionId) {
  return request({
    url: `/amc-question-feedback/list-by-question/${questionId}`,
    method: 'get'
  })
}

/**
 * 根据状态查询反馈列表
 */
export function getFeedbackByStatus(status) {
  return request({
    url: `/amc-question-feedback/list-by-status/${status}`,
    method: 'get'
  })
}

/**
 * 查询所有反馈
 */
export function getAllFeedback() {
  return request({
    url: '/amc-question-feedback/list-all',
    method: 'get'
  })
}

/**
 * 处理反馈
 */
export function handleFeedback(data) {
  return request({
    url: '/amc-question-feedback/handle',
    method: 'post',
    data
  })
}

/**
 * 获取待处理反馈数量
 */
export function getPendingCount() {
  return request({
    url: '/amc-question-feedback/pending-count',
    method: 'get'
  })
}

/**
 * 获取反馈统计信息
 */
export function getStatistics() {
  return request({
    url: '/amc-question-feedback/statistics',
    method: 'get'
  })
}
